


















































































































































































































































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import {
  store,
  bus,
  client,
  checkAuth,
  toPascalCase,
  splitOnFirst,
} from '../shared';
import { validationMixin } from 'vuelidate';
import {
  CheckUsername,
  CheckEmail,
  CheckExistingIIDPUsername,
  CheckExistingIIDPEmail,
  Register,
  CheckFirstLastName,
  CheckUserFirstLastName,
} from '../shared/dtos';
import { Routes, redirect } from '../shared/router';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  minLength,
  between,
  email,
  decimal,
  integer,
  url,
  sameAs,
  alphaNum,
  isUnique,
} from 'vuelidate/lib/validators';
import VueSweetalert2 from 'vue-sweetalert2';
import _ from 'lodash';
@Component({
  components: {},
})
export class SignUp extends Vue {
  $v: any;
  mixins: ['validationMixin'];
  submitted = false;
  iidpSecure: any = '';
  hasDuplicateName: boolean = false;
  form: any = {
    email: null,
    firstName: null,
    lastName: null,
    userName: null,
    password: null,
    company: null,
    confirmPassword: null,
  };
  autoLogin = false;
  loading = false;
  responseStatus = null;
  @Validations()
  validations: any = {
    form: {
      email: {
        required,
        email,
        async isUnique(email: any) {
          if (email === '') {
            return true;
          }
          const r = await client.get(new CheckEmail({ email }));
          return !r.result;
        },
        async isUniqueExistingIIDPEmail(email: any) {
          if (email === '') {
            return true;
          }
          const r = await client.get(new CheckExistingIIDPEmail({ email }));
          return !r.result;
        },
      },
      firstName: {
          required,
          minLength: minLength(2),
      },
      lastName: {
          required,
          minLength: minLength(2),
      },
      userName: {
        required,
        minLength: minLength(3),
        alphaNum,
        async isUnique(userName: any) {
          if (userName === '' || userName === undefined) {
            return false;
          }
          const r = await client.get(new CheckUsername({ userName }));
          return !r.result;
        },
        async isUniqueExistingIIDPUsername(userName: any) {
          if (userName === '' || userName === undefined) {
            return false;
          }
          const r = await client.get(
            new CheckExistingIIDPUsername({ userName }),
          );
          return !r.result;
        },
      },
      password: {
        required,
        minLength: minLength(5),
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
      company: {
          required,
          minLength: minLength(2),
      },
    },
  };
  isValidName(value: any) {
    const char = String.fromCharCode(value.keyCode);
    if (/^[a-z\d\-_'.\s]+$/i.test(char)) {
      return true;
    } else {
      value.preventDefault();
    }
  }
  async checkUsername(userName: string) {
    if (userName !== undefined) {
      const r = await client.get(new CheckUsername({ userName }));
    }
  }
  async checkExistingIIDPUsername(userName: string) {
    if (userName !== undefined) {
      const r = await client.get(new CheckExistingIIDPUsername({ userName }));
    }
  }
  async checkEmail() {
    const d = await client.get(new CheckEmail({ email }));
  }
  async checkExistingIIDPEmail() {
    const d = await client.get(new CheckExistingIIDPEmail({ email }));
  }

    async checkFirstLastName(lastName: string, form: any) {
    if (
      this.form.lastName === '' ||
        this.form.lastName === undefined ||
        this.form.lastName === null ||
      this.form.firstName === null ||
        this.form.firstName === '' ||
        this.form.lastName === null
    ) {
      return true;
    }
    const d = await client.get(
      new CheckFirstLastName({
        firstName: this.form.firstName,
        lastName: this.form.lastName,
      }),
    );
    const e = await client.get(
      new CheckUserFirstLastName({
        firstName: this.form.firstName,
        lastName: this.form.lastName,
      }),
    );
    if (d.result || e.result) {
      this.hasDuplicateName = true;
    } else {
      this.hasDuplicateName = false;
    }
  }

  async submit() {
    try {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      // emit
      this.loading = true;
      this.responseStatus = null;
      const response = await client.post(
        new Register({
          FirstName: this.form.firstName,
          lastName: this.form.lastName,
          userName: this.form.userName,
          password: this.form.password,
          confirmPassword: this.form.confirmPassword,
          email: this.form.email,
          meta: { company: this.form.company },
          autoLogin: this.form.autoLogin,
        }),
      );
      this.submitted = true;
      this.$swal(
        'Registration Submitted',
        'To complete the registration process, please verify your account by checking your inbox for an IIDP email and click the verify email link.',
        'success',
      ).then(() => {
        redirect(Routes.Home);
      });
      // await checkAuth();
      // redirect(Routes.Home);
    } catch (e) {
      this.responseStatus = e.responseStatus || e;
    } finally {
      this.loading = false;
    }
  }
  mounted() {
      const iidpSecureUrl = IIDPconfig.SECURE_URL as string;
      this.iidpSecure = `${iidpSecureUrl}/${IIDPconfig.SECURE_URL_INVESTIGATOR_LOGIN as string}`;
  }
}
export default SignUp;
